/* eslint-disable @typescript-eslint/no-unused-vars */

// ICU MessageFormat plural categories
// See: https://unicode-org.github.io/icu/userguide/format_parse/messages/
export type PluralKinds = {
  other: string; // Required fallback
  zero?: string;
  one?: string;
  two?: string;
  few?: string; // Language-specific (e.g., 2-4 in Polish)
  many?: string; // Language-specific (e.g., 5+ in Arabic)
  [exactly: number]: string; // Exact match (e.g., =0, =100)
};

/**
 * Handles pluralization: plural(count, { zero, one, other }) or plural(count, 'other', 'one', 'zero')
 *
 * @param count - The number to pluralize for
 * @param cases - Either an object with plural categories or the 'other' string for shorthand
 * @param one - Optional singular form (shorthand only)
 * @param zero - Optional zero form (shorthand only)
 * @returns The appropriate text for the given count
 */
export function plural(count: number, cases: PluralKinds): string;
export function plural(
  count: number,
  other: string,
  one?: string,
  zero?: string
): string;
export function plural(...__: any): string {
  throw new StubError('plural');
}

export type SelectKinds = {
  other: string; // Required fallback
  [key: string]: string;
};

/**
 * Switch statement for translations: select(status, { active: 'Active', other: 'Unknown' })
 *
 * @param value - The value to match against
 * @param cases - Object mapping values to their text (must include 'other' as fallback)
 * @returns The matching text, or the 'other' fallback
 */
export function select(value: string, cases: SelectKinds): string {
  throw new StubError('select');
}

/**
 * Formats a number according to the given format.
 *
 * @param value the number to format
 * @param skeleton ICU number skeleton (https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html)
 */
export function number(value: number, skeleton?: string): string {
  throw new StubError('number');
}

export function date(
  value: Date | number | string,
  format?: 'short' | 'medium' | 'long' | 'full'
): string {
  throw new StubError('date');
}

export function time(
  value: Date | number | string,
  format?: 'short' | 'medium' | 'long' | 'full'
): string {
  throw new StubError('time');
}

class StubError extends Error {
  constructor(name: string) {
    super(`${name}() is an ICU formatter stub which should never be called directly
      Formatters should only be used within a const TEXT = localizeText(...) block, where
      they will be statically compiled into translatable string (ICU) messages.

      See @frameio/i18n/README.md`);
  }
}
